(() => {
  const CONFIG = {
    enabled: true,
    fadeOutDuration: 500,
    processingDelay: 50,
    pageSelectors: ['.collection__content'],
    cardSelectors: ['.f-column.card'],
    productTypes: {
      lips: [
        'lip liner', 'lip oil', 'lip stain', 'liquid shimmer',
        'liquid to matte lipstick', 'luxury matte lipstick',
        'luxury cream lipstick', 'lip gloss', 'lip pencil'
      ]
    }
  };

  // Check if a product has at least one enabled group
  const hasEnabledGroup = (card) => {
    const groupElements = card.querySelectorAll('[type-group="true"]');
    if (!groupElements.length) return false;

    return Array.from(groupElements).some(groupElement => {
      const hiddenInput = groupElement.querySelector('input[type="hidden"]');
      return !(hiddenInput?.value === 'Product group hidden or current product not present.');
    });
  };

  // Helper to get all product info with multiple groups
  const getProductInfo = (card) => {
    const groupElements = card.querySelectorAll('[type-group="true"]');
    if (!groupElements.length) return null;

    // Get all valid groups (not disabled)
    const validGroups = Array.from(groupElements).filter(groupElement => {
      const hiddenInput = groupElement.querySelector('input[type="hidden"]');
      return !(hiddenInput?.value === 'Product group hidden or current product not present.');
    });

    // If no valid groups, return null
    if (!validGroups.length) return null;

    // Return info with the first valid group's ID
    return {
      title: card.querySelector('.product-card__title')?.textContent?.trim() || '',
      type: card.querySelector('.product-card__type')?.textContent?.trim() || '',
      groupId: validGroups[0].getAttribute('option-target')
    };
  };

  // Card visibility handlers
  const hideCard = (card) => {
    card.style.opacity = '0';
    setTimeout(() => {
      card.style.display = 'none';
    }, CONFIG.fadeOutDuration);
  };

  const showCard = (card) => {
    card.style.display = '';
    card.style.opacity = '1';
  };

  // Add required styles
  const addStyles = () => {
    if (document.getElementById('product-group-styles')) return;
    
    const style = document.createElement('style');
    style.id = 'product-group-styles';
    style.textContent = `
      ${CONFIG.cardSelectors.join(', ')} {
        transition: opacity ${CONFIG.fadeOutDuration}ms ease-out;
      }
    `;
    document.head.appendChild(style);
  };

  // Main processing function
  const processProducts = (container) => {
    const cards = Array.from(container.querySelectorAll(CONFIG.cardSelectors.join(', ')));
    if (!cards.length) return;

    const groupedCards = new Map();
    let visibleCount = 0;
    
    // First pass: Group cards by their active groups
    cards.forEach(card => {
      // Skip if card has no enabled groups at all
      if (!hasEnabledGroup(card)) {
        visibleCount++;
        return;
      }

      const info = getProductInfo(card);
      if (!info || !info.groupId) {
        visibleCount++;
        return;
      }

      if (!groupedCards.has(info.groupId)) {
        groupedCards.set(info.groupId, []);
      }
      groupedCards.get(info.groupId).push({
        card,
        info
      });
    });

    // Second pass: Process each group
    groupedCards.forEach((groupCards) => {
      if (groupCards.length === 0) return;

      // Show first card in group
      showCard(groupCards[0].card);
      visibleCount++;

      // Hide all other cards in group
      for (let i = 1; i < groupCards.length; i++) {
        hideCard(groupCards[i].card);
      }
    });

    // Update product count
    const countElement = document.getElementById('ProductCount');
    if (countElement) {
      countElement.textContent = `${visibleCount} products`;
    }
  };

  const init = () => {
    if (!CONFIG.enabled) return;
    addStyles();

    CONFIG.pageSelectors.forEach(selector => {
      const container = document.querySelector(selector);
      if (!container) return;

      processProducts(container);

      // Handle "Show more" button
      const loadMoreButton = document.querySelector('button[type="load_more"]');
      if (loadMoreButton) {
        loadMoreButton.addEventListener('click', () => {
          setTimeout(() => processProducts(container), CONFIG.processingDelay);
        });
      }

      // Observe for changes
      const observer = new MutationObserver((mutations) => {
        let shouldProcess = false;
        mutations.forEach(mutation => {
          if (mutation.type === 'childList' && 
              (mutation.target.classList.contains('products-list') || 
               mutation.target.closest('.products-list'))) {
            shouldProcess = true;
          }
        });
        if (shouldProcess) {
          setTimeout(() => processProducts(container), CONFIG.processingDelay);
        }
      });

      observer.observe(container, { 
        childList: true, 
        subtree: true 
      });
    });
  };

  let attempts = 0;
  const checkInit = () => {
    if (window.VariantSwatchKing || attempts > 50) {
      init();
    } else {
      attempts++;
      setTimeout(checkInit, 100);
    }
  };
  checkInit();
})();